var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.095 2.5H24.3275C26.0803 2.5 27.5006 3.93231 27.5006 5.69995V9.96816C27.5006 11.7358 26.0803 13.1681 24.3275 13.1681H20.095C18.3422 13.1681 16.9219 11.7358 16.9219 9.96816V5.69995C16.9219 3.93231 18.3422 2.5 20.095 2.5Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90561 16.8319C11.6584 16.8319 13.0788 18.2642 13.0788 20.0318V24.3C13.0788 26.0665 11.6584 27.5 9.90561 27.5H5.67316C3.92032 27.5 2.5 26.0665 2.5 24.3V20.0318C2.5 18.2642 3.92032 16.8319 5.67316 16.8319H9.90561ZM24.3268 16.8319C26.0797 16.8319 27.5 18.2642 27.5 20.0318V24.3C27.5 26.0665 26.0797 27.5 24.3268 27.5H20.0944C18.3416 27.5 16.9212 26.0665 16.9212 24.3V20.0318C16.9212 18.2642 18.3416 16.8319 20.0944 16.8319H24.3268ZM9.90561 2.5C11.6584 2.5 13.0788 3.93231 13.0788 5.69995V9.96816C13.0788 11.7358 11.6584 13.1681 9.90561 13.1681H5.67316C3.92032 13.1681 2.5 11.7358 2.5 9.96816V5.69995C2.5 3.93231 3.92032 2.5 5.67316 2.5H9.90561Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAll);
export default __webpack_public_path__ + "static/media/view-all.82dfc2ec6ff680b4227a900b204f1fdb.svg";
export { ForwardRef as ReactComponent };